import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import queryString from "query-string";
import { swSettings } from "app/common/services/swSettings";
import { allTrackers } from "app/services/track/track";

export const ExcelDownload = ({ queryParams, metricName }) => {
    const defaultExcelEndPoint = "widgetApi/TrafficSourcesSearchV2/SearchOrganicPaidOverview/Excel";
    const getExcel = (prefix) => (apiParams) => prefix + "?" + queryString.stringify(apiParams);
    const getExcelLink = getExcel(defaultExcelEndPoint);
    const excelLink = getExcelLink ? getExcelLink(queryParams) : null;
    const onExcelClick = () => {
        allTrackers.dispatchTrackEvent(
            "Download",
            "submit-ok",
            `Over Time Graph/Search Overview/${metricName || ""}/Excel`,
        );
    };
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;

    return (
        <DownloadButtonMenu
            Excel={true}
            downloadUrl={excelLink}
            exportFunction={onExcelClick}
            excelLocked={!downloadExcelPermitted}
        />
    );
};
